import FastTooltip from "components/fast_tooltip";
import { useWkSelector } from "libs/react_hooks";
import { useDispatch } from "react-redux";
import { AnnotationTool } from "viewer/model/accessors/tool_accessor";
import { getHideUnregisteredSegmentsForLayer } from "viewer/model/accessors/volumetracing_accessor";
import { setHideUnregisteredSegmentsAction } from "viewer/model/actions/volumetracing_actions";
import SwitchSetting from "./components/switch_setting";

export function HideUnregisteredSegmentsSwitch({ layerName }: { layerName: string }) {
  const dispatch = useDispatch();
  const activeTool = useWkSelector((state) => state.uiInformation.activeTool);

  const isProofreadingMode = activeTool === AnnotationTool.PROOFREAD;
  const selectiveVisibilityInProofreading = useWkSelector(
    (state) => state.userConfiguration.selectiveVisibilityInProofreading,
  );
  const isHideUnregisteredSegmentsDisabled =
    isProofreadingMode && selectiveVisibilityInProofreading;
  const hideUnregisteredSegments = useWkSelector((state) =>
    getHideUnregisteredSegmentsForLayer(state, layerName),
  );

  return (
    <FastTooltip
      title={
        isHideUnregisteredSegmentsDisabled
          ? "This behavior is overridden by the enabled 'selective segment visibility' feature in the toolbar that belongs to the proofreading tool."
          : "When enabled, segments that were not added to the segment list are hidden by default."
      }
    >
      <div
        style={{
          marginBottom: 6,
        }}
      >
        <SwitchSetting
          onChange={() => {
            dispatch(setHideUnregisteredSegmentsAction(!hideUnregisteredSegments, layerName));
          }}
          value={hideUnregisteredSegments}
          label={"Hide unlisted segments"}
          disabled={isHideUnregisteredSegmentsDisabled}
        />
      </div>
    </FastTooltip>
  );
}
